/* ═══════════════════════════════════════════════════════════════
   PureEthical — pe-conversion.js  v257
   Conversion engine: urgency, UX improvements, micro-interactions
   No fake social proof. Only honest, useful signals.
   ═══════════════════════════════════════════════════════════════ */
(function () {
'use strict';

/* ── Premium toast (replaces old msg()) ─────────────────────── */
window.peToast = function (text, duration) {
  var ex = document.querySelector('.pe-toast');
  if (ex) { ex.classList.add('out'); }
  var el = document.createElement('div');
  el.className = 'pe-toast';
  el.textContent = text;
  document.body.appendChild(el);
  var d = duration || 2800;
  setTimeout(function () {
    el.classList.add('out');
    setTimeout(function () { if (el.parentNode) el.remove(); }, 320);
  }, d);
};

/* ═══════════════════════════════════════════════════════════
   PRODUCT PAGE
═══════════════════════════════════════════════════════════ */
document.addEventListener('DOMContentLoaded', function () {

  var isProduct = !!document.querySelector('.gs-prod-layout, .gs-atc-btn');
  if (!isProduct) return;

  /* ── 1. ATC SIZE VALIDATION — CAPTURE PHASE (fires before theme.js) ── */
  /*
     We intercept in CAPTURE phase so we run BEFORE the bubble-phase
     listener in theme.js that does the actual cartAdd. If no size is
     explicitly chosen, we block and shake. We track whether the user
     has clicked a size button via data-user-picked attribute.
  */
  (function () {
    var sizeGrid  = document.querySelector('.gs-size-grid');
    var sizeLabel = document.querySelector('.gs-size-label');
    if (!sizeGrid) return; /* no sizes — nothing to validate */

    /* Mark the initial "on" button as NOT user-picked (pre-selected by template) */
    /* User must actively click to mark as picked */
    var initialOn = sizeGrid.querySelector('.sz-btn.on');
    /* We do NOT set data-user-picked on it — user hasn't clicked yet */

    /* When user clicks a size button → mark as picked */
    sizeGrid.addEventListener('click', function (e) {
      var btn = e.target.closest('.sz-btn:not(.sz-sold-out)');
      if (!btn) return;
      sizeGrid.querySelectorAll('.sz-btn').forEach(function (b) {
        b.removeAttribute('data-user-picked');
      });
      btn.dataset.userPicked = '1';
    });

    /* Auto-pick the first available size if none picked yet */
    /* Size auto-pick REMOVED: adding to bag must never silently choose a
       size for the customer. Selection is enforced in theme.js's ATC
       handler; the only auto-selection kept is the single-size case,
       where there is genuinely nothing to choose. */
    (function autoPickIfOnlyOne() {
      var available = sizeGrid.querySelectorAll('.sz-btn:not(.sz-sold-out)');
      if (available.length === 1) available[0].click();
    })();

  })();

/* ═══════════════════════════════════════════════════════════════
   MOBILE GALLERY — scroll-sync dots + correct swapSliderImages
   pe-conversion loads AFTER theme.js → this is the final version
═══════════════════════════════════════════════════════════════ */
(function () {

  /* ── Override swapSliderImages (theme.js uses .gs-slide, we need .gs-img-item) ── */
  window.swapSliderImages = function (images, zooms) {
    var slider = document.getElementById('galSlider');
    if (!slider) return;

    /* Reset grid modifiers */
    slider.classList.remove('gs-img-grid--single', 'gs-img-grid--three');
    if (images.length === 1)      slider.classList.add('gs-img-grid--single');
    else if (images.length === 3) slider.classList.add('gs-img-grid--three');

    /* Rebuild with gs-img-item (works with mobile CSS scroll-snap) */
    slider.innerHTML = '';
    images.forEach(function (src, i) {
      var d   = document.createElement('div');
      d.className       = 'gs-img-item';
      d.dataset.index   = i;
      var img           = document.createElement('img');
      img.src           = src;
      img.alt           = '';
      img.loading       = i === 0 ? 'eager' : 'lazy';
      img.dataset.zoom  = zooms[i] || src;
      img.draggable     = false;
      d.appendChild(img);
      slider.appendChild(d);
    });

    /* Rebuild dots */
    var dotsW = document.getElementById('galDots');
    if (dotsW) {
      dotsW.innerHTML = '';
      if (images.length > 1) {
        dotsW.style.display = '';
        images.forEach(function (_, i) {
          var b = document.createElement('button');
          b.className = 'gal-dot' + (i === 0 ? ' on' : '');
          b.dataset.index = String(i);
          b.setAttribute('aria-label', 'Image ' + (i + 1));
          dotsW.appendChild(b);
        });
      } else {
        dotsW.style.display = 'none';
      }
    }

    /* Reset scroll position */
    slider.scrollLeft = 0;
  };

  /* ── Mobile scroll → sync dots ── */
  document.addEventListener('DOMContentLoaded', function () {
    var slider = document.getElementById('galSlider');
    var dotsW  = document.getElementById('galDots');
    if (!slider) return;

    function updateDots () {
      if (!dotsW) return;
      var w   = slider.clientWidth;
      if (!w) return;
      var idx = Math.round(slider.scrollLeft / w);
      dotsW.querySelectorAll('.gal-dot').forEach(function (d, i) {
        d.classList.toggle('on', i === idx);
      });
    }

    /* Scroll listener — passive for performance */
    slider.addEventListener('scroll', updateDots, { passive: true });

    /* Dot click → smooth scroll to correct image */
    if (dotsW) {
      dotsW.addEventListener('click', function (e) {
        var dot = e.target.closest('.gal-dot');
        if (!dot) return;
        var idx = parseInt(dot.dataset.index) || 0;
        slider.scrollTo({ left: idx * slider.clientWidth, behavior: 'smooth' });
      });
    }

    /* Touch swipe on mobile (redundant with CSS snap but improves responsiveness) */
    var sx = 0, sScrollL = 0;
    slider.addEventListener('touchstart', function (e) {
      sx = e.touches[0].clientX;
      sScrollL = slider.scrollLeft;
    }, { passive: true });

    slider.addEventListener('touchend', function (e) {
      /* CSS snap handles the snap — we just ensure dots sync after */
      setTimeout(updateDots, 350);
    }, { passive: true });

    /* Initial sync */
    updateDots();
  });

})();

  /* ── 2. Low stock urgency (real data from DOM) ─────────────── */
  (function () {
    var panel = document.getElementById('stockUrgencyPanel');
    if (!panel) return;

    function checkStock () {
      /* Find lowest stock among available sizes */
      var lowestStock = null;
      document.querySelectorAll('.sz-btn:not(.sz-sold-out)').forEach(function (b) {
        var qty = parseInt(b.dataset.lowStock);
        if (qty > 0 && (lowestStock === null || qty < lowestStock)) lowestStock = qty;
      });

      if (lowestStock !== null && lowestStock <= 5) {
        panel.style.display = 'flex';
        var msgEl = panel.querySelector('#stockMsg');
        if (msgEl) {
          msgEl.textContent = lowestStock === 1
            ? window.PE_T('only_one','Only 1 item left in this size!')
            : window.PE_T('only_left','Only {n} left — selling fast').replace('{n}', lowestStock);
        }
      } else {
        panel.style.display = 'none';
      }
    }

    checkStock();
    /* Re-check when color variant changes */
    document.addEventListener('click', function (e) {
      if (e.target.closest('.gs-color-thumb') || e.target.closest('.sz-btn')) {
        setTimeout(checkStock, 60);
      }
    });
  })();

  /* ── 3. ATC button micro-interaction ───────────────────────── */
  (function () {
    var atcBtn = document.getElementById('prodAtcBtn');
    if (!atcBtn) return;
    /* We enhance the AFTER-success state — listen for when cart updates */
    var _origObserver = window.cartAdd;
    if (typeof window.cartAdd === 'function') {
      window.cartAdd = function (id, qty, ok, fail) {
        return _origObserver(id, qty, function (data) {
          /* v27: primeiro o callback do theme.js repoe o texto original;
             so depois se le o texto para o repor. Antes lia-se "A adicionar..."
             e o botao ficava preso nesse texto. Cor da marca, nao verde. */
          if (ok) ok(data);
          var orig = atcBtn.textContent;
          var done = window.PE_T('added','✓  Added to bag');
          atcBtn.classList.add('pe-atc-done');
          atcBtn.textContent = done;
          setTimeout(function () {
            atcBtn.classList.remove('pe-atc-done');
            if (atcBtn.textContent === done) atcBtn.textContent = orig;
          }, 2200);
        }, fail);
      };
    }
  })();

  /* ── 4. Inject urgency HTML ────────────────────────────────── */
  if (!document.getElementById('stockUrgencyPanel')) {
    var atcWrap = document.querySelector('.gs-atc-wrap');
    if (atcWrap) {
      var su = document.createElement('div');
      su.id = 'stockUrgencyPanel';
      su.className = 'pe-urgency-bar';
      su.style.display = 'none';
      su.innerHTML =
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>' +
        '<span id="stockMsg"></span>';
      atcWrap.insertAdjacentElement('beforebegin', su);
    }
  }

}); /* end DOMContentLoaded */

/* ═══════════════════════════════════════════════════════════
   COLLECTION — staggered card entrance
═══════════════════════════════════════════════════════════ */
document.addEventListener('DOMContentLoaded', function () {
  var isColl = !!document.querySelector('.coll-pgrid, .pgrid');
  if (!isColl) return;

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateY(0)';
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.04, rootMargin: '0px 0px -10px 0px' });

    document.querySelectorAll('.product-card').forEach(function (card, i) {
      card.style.opacity = '0';
      card.style.transform = 'translateY(16px)';
      card.style.transition = 'opacity .42s ease ' + (i % 3 * 55) + 'ms, transform .42s ease ' + (i % 3 * 55) + 'ms';
      io.observe(card);
    });
  }
});

/* v35: o botao "voltar ao topo" deste ficheiro saiu - duplicava o #scrollTopBtn do layout (mesma posicao, rotulo so em ingles). */

/* ═══════════════════════════════════════════════════════════
   IMAGE KEYBOARD SHORTCUT  (Z = zoom)
═══════════════════════════════════════════════════════════ */
document.addEventListener('keydown', function (e) {
  /* v34: nao disparar enquanto se escreve (pesquisa, newsletter, email) */
  if (e.ctrlKey || e.metaKey || e.altKey || (e.target && e.target.closest && e.target.closest('input,textarea,select,[contenteditable]'))) return;
  if (e.key === 'z' || e.key === 'Z') {
    var first = document.querySelector('.gs-img-item');
    if (first) first.click();
  }
});

})();
